/*
 * @Description: 
 * @Author: CC
 * @Date: 2021-03-31 14:49:41
 * @LastEditTime: 2021-04-17 18:25:04
 */
import { observable, computed, action } from 'mobx';

class Voice {
  @observable user = {
    avatar: '', // img_1732864_1602216037__400x400.jpg
    nick: '', // 坏妹妹～
  }
  @observable main = '' // 萝莉音
  @observable platform = 0 // 平台
  @observable evaluation = '' // 99
  @observable cp = '' // 猛男音
  @observable score = [
    {
      name: '',
      score: '',
    },
  ]
  @observable auxiliary = [
    // { probability: '22%', name: '哈哈哈哈哈哈哈' },
    { probability: '', name: '' },
  ]

  @action setUser = (user) => {
    this.user = user
  }

  @action setMain = (main) => {
    this.main = main
  }

  @action setEvaluation = (evaluation) => {
    this.evaluation = evaluation
  }

  @action setCp = (cp) => {
    this.cp = cp
  }

  @action setScore = (score) => {
    this.score = score
  }

  @action setAuxiliary = (auxiliary) => {
    this.auxiliary = auxiliary
  }

  @action setPlatform = (platform) => {
    this.platform = platform
  }

  @computed get getUser() {
    return this.user
  }

  @computed get getMain() {
    return this.main
  }

  @computed get getEvaluation() {
    return this.evaluation
  }

  @computed get getCp() {
    return this.cp
  }

  @computed get getScore() {
    return this.score
  }

  @computed get getAuxiliary() {
    return this.auxiliary
  }

  @computed get getPlatform() {
    return this.platform
  }
}

export default Voice;